import { useEffect, useState } from 'react';

const getQueryList = (query) => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null;
  try {
    return window.matchMedia(query);
  } catch (error) {
    return null;
  }
};

// Whether a CSS media query matches, kept current as the window changes.
// False where matchMedia isn't available.
export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() => getQueryList(query)?.matches ?? false);

  useEffect(() => {
    const queryList = getQueryList(query);
    if (!queryList) return undefined;

    setMatches(queryList.matches);
    const onChange = (event) => setMatches(event.matches);

    // Safari < 14 only supports the older addListener/removeListener pair.
    if (typeof queryList.addEventListener === 'function') {
      queryList.addEventListener('change', onChange);
      return () => queryList.removeEventListener('change', onChange);
    }
    queryList.addListener(onChange);
    return () => queryList.removeListener(onChange);
  }, [query]);

  return matches;
};
